export class ScrollTop {

    constructor() {
        this.showScrollTop();
    }

    showScrollTop() {
        if ($(window).scrollTop() > 10) {
            $('.back-to-top').addClass('show');
        }
        else {
            $('.back-to-top').removeClass('show');
        }
    }
}



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Theme/ScrollTop.js